import { getCollectionActionTypes } from '@framework/state/Redux/collectionFactory';

export const keyWord = 'LEAGUE_TABLE_TOP_UNDERWRITERS';
export const config = { withItemsPerPage: false };

export default getCollectionActionTypes(keyWord, config);
